const SPOTIFY =
  /open\.spotify\.com\/(?:intl-[a-z]{2}\/)?(track|album|playlist|episode|show)\/([a-zA-Z0-9]+)/

export function spotifyEmbedUrl(url: string | null | undefined): string | null {
  if (!url) return null
  const match = url.match(SPOTIFY)
  if (!match) return null
  return `https://open.spotify.com/embed/${match[1]}/${match[2]}?theme=0`
}

const YOUTUBE =
  /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

export function youtubeEmbedUrl(url: string | null | undefined): string | null {
  if (!url) return null
  const match = url.match(YOUTUBE)
  if (!match) return null
  return `https://www.youtube.com/embed/${match[1]}`
}
